import { Model } from '@/clients/http'

import { SmsGatewayHttpParams, SmsGatewayResponses } from '@/types'

export class SmsGatewayModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_SMS_GATEWAY_LIST',
    GET_BY_KEY: 'GET_SMS_GATEWAY_BY_KEY',
    UPDATE: 'UPDATE_SMS_GATEWAY',
  }

  public static readonly endpoints = {
    getList: (props?: SmsGatewayHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/sms-gateway',
        params: props?.params,
        query: props?.query,
      }),

    getByKey: (props: SmsGatewayHttpParams.GetByKey) =>
      this.createEndpoint({
        url: '/api/backoffice/sms-gateway/:key',
        params: props?.params,
        query: props?.query,
      }),

    update: (props: SmsGatewayHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/sms-gateway/:key',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (props?: SmsGatewayHttpParams.GetList) => {
    return this.createHttpRequest<SmsGatewayResponses.GetList, SmsGatewayResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
    })
  }

  public static readonly getByKey = async (props: SmsGatewayHttpParams.GetByKey) => {
    return this.createHttpRequest<SmsGatewayResponses.GetByKey, SmsGatewayResponses.GetByKeyError>({
      correlationKey: this.correlations.GET_BY_KEY,
      payload: {
        method: 'get',
        url: this.endpoints.getByKey(props),
        useBearerToken: true,
      },
    })
  }

  public static readonly update = async (props: SmsGatewayHttpParams.Update) => {
    return this.createHttpRequest<SmsGatewayResponses.Update, SmsGatewayResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
    })
  }
}
